var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import $ from 'jquery';
import { sleep } from '../helper';
import '../css/app.css';
import '../css/message.css';
import '../css/spinner.css';
import { appendMessage, isSteveTyping } from './helper';
$(function () {
    const loading = $('.spinner-container');
    const input = $('#input');
    const submit = $('#submit');
    const steve = $('.message.typing');
    let threadId = null;
    const url = `${process.env.API_BASE_URL}/chat/ask`;
    let newMsg = '';
    const askApi = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield disableEvents();
            const response = yield fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ query: newMsg, threadId })
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const result = yield response.json();
            // Remember thread
            threadId = result.threadId;
            if (threadId)
                sessionStorage.setItem('threadId', threadId);
            appendMessage(result.assistantResponse, 'assistant');
            return result.data;
        }
        catch (error) {
            console.error('Error:', error);
        }
        finally {
            yield enableEvents();
        }
    });
    const submitWithoutVer = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        // Append to chat messages
        appendMessage(newMsg, 'user');
        input.val("");
        (_a = input.get(0)) === null || _a === void 0 ? void 0 : _a.focus();
        yield askApi();
    });
    const disableEvents = () => __awaiter(this, void 0, void 0, function* () {
        submit.prop('disabled', true);
        submit.hide();
        steve.show();
        loading.css('display', 'flex');
        // input.prop('disabled', true);
        yield toggleSteve();
        animTypingIndicator();
    });
    const enableEvents = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        submit.prop('disabled', false);
        loading.hide();
        submit.show();
        steve.hide();
        // input.prop('disabled', false);
        yield toggleSteve(false);
        (_a = input.get(0)) === null || _a === void 0 ? void 0 : _a.focus();
    });
    const toggleSteve = (...args_1) => __awaiter(this, [...args_1], void 0, function* (show = true) {
        if (show) {
            yield sleep(0.5);
            appendMessage('Steve is typing', 'typing');
        }
        else
            $('.message.typing').remove();
    });
    let typingTmr;
    const animTypingIndicator = () => {
        const baseText = "Steve is typing";
        let dotCount = 0;
        typingTmr = setInterval(() => {
            const typingText = $('.message.typing');
            if (!typingText.length)
                return clearInterval(typingTmr);
            dotCount = (dotCount + 1) % 4; // cycle dotCount through 0, 1, 2, 3
            typingText.text(baseText + " .".repeat(dotCount));
        }, 500); // change interval as needed for speed
    };
    submit.on('click', () => {
        if (isSteveTyping())
            return;
        newMsg = input.val();
        newMsg.trim().length && submitWithoutVer();
    });
    input.on('keydown', (event) => {
        if (isSteveTyping())
            return;
        newMsg = input.val();
        event.key === 'Enter' && newMsg.trim().length && submitWithoutVer();
    });
    // Load thread from sessionStorage
    threadId = sessionStorage.getItem('threadId');
});
